<script lang="typescript">

    import Subtitle2 from "./typography/subtitle2.svelte";

    export let text = "My Item Text";
    export let icon: any;

    export let active = false;
    export let activeColor = "var(--color-primary)";

    let iActive = active;
    $: {
        iActive = active;
    }
</script>

<li class="menu-item" on:click>
    <div class="icon">
        <svelte:component
            this={icon}
            color={iActive ? activeColor : "var(--color-level-8)"}
            width={24}
            height={24}
        />
    </div>
    <Subtitle2 color={iActive ? activeColor : "var(--color-level-8)"} {text} />
</li>

<style>
    :root {
        --mitem-hover: rgba(var(--color-primary-value), 0.1);
        --mitem-hover-alpha: 0.5;
    }

    .menu-item {
        display: flex;
        flex-direction: row;
        padding: 14px 16px 16px 16px;
        height: 48px;
        cursor: pointer;
    }
    .menu-item:hover {
        background-color: var(--mitem-hover, rgba(187, 134, 252, 0.3));
    }
    .icon {
        width: 24px;
        height: 24px;
        margin-right: 34px;
    }
</style>
